import Pages from './pages/form.js'
import Navbar from './components/navbar/Navbar.jsx'
import "./styles.css";

const App = () => {
  return(
    <div>
      <Navbar/>
      <Pages/>
    </div>
    
  );
}

export default App;
